import React, { useContext, useState } from "react";
import { Row, Col, Tabs, Container, Tab } from "react-bootstrap";
import Statics from "../Statics";
import ComponentContext from "../Context";
import DocumentMeta from "react-document-meta";
import kargah from "../Images/kargah.png";
import noWorkshopHero from "../Images/noWork.png";
import Config from "../config.json";
import Loading from "./Loading";
import { Link } from "react-router-dom";
import Teachers from "./Teachers";
import { useHash } from "../lib/hooks";

const WorkshopMeetingRow = props => {
  const { meetingNo, session } = props;
  return (
    <Row className="mx-0">
      <div className="text-right">
        <span className="mx-1">جلسه {meetingNo} :</span>
        <span>
          {session.start_date.year}/{session.start_date.month}/
          {session.start_date.day} {session.start_date.hour}:
          {("0" + session.start_date.minute).slice(-2)}
        </span>
        {" تا "}
        <span>
          {session.finish_date.hour}:
          {("0" + session.finish_date.minute).slice(-2)}
        </span>
      </div>
    </Row>
  );
};

const page_meta = {
  language: "fa",
  copyright: "پژوهیار",
  description: "نرم‌افزار استناددهی",
  title: Config.title + " | کارگاه",
  meta: {
    charset: "utf-8",
    name: {
      keywords: "پژوهیار",
    },
  },
};

const ACCEPTABLE_HASHES = ["workshop-list", "teacher-list"];

const WorkShop = () => {
  const [workshops, set_workshops] = useState(null);
  const context = useContext(ComponentContext);
  const selectedTab = useHash(ACCEPTABLE_HASHES);
  const [loading_state, set_loading_state] = useState(Statics.NOT_LOADED);

  const getWorkshops = () => {
    set_loading_state(Statics.LOADING);
    const stored = sessionStorage.getItem("allWorkshops");
    if (stored) {
      set_workshops(JSON.parse(stored));
      set_loading_state(Statics.LOADED);
    } else {
      context.ApiDriver.searchWorkshops(
        {},
        data => {
          set_workshops(data.data);
          sessionStorage.setItem("allWorkshops", JSON.stringify(data.data));
          set_loading_state(Statics.LOADED);
        },
        error => {
          console.error(error);
          set_loading_state(Statics.CAUSED_ERROR);
        },
      );
    }
  };

  if (loading_state === Statics.NOT_LOADED) {
    getWorkshops();
  }

  return (
    <DocumentMeta {...page_meta}>
      <section className="hero-sample">
        <div className="hero-sample-right">
          <h1>کارگاه‌های آموزشی در پژوهیار</h1>
          <p className="text-justify">
            به منظور فراگیریِ بهتر پژوهیار، دوره‌های آموزشی در سه سطح در نظر
            گرفته شده است. برای درخواست کارگاه و کلاس آموزشی از طریق فرم ثبت نام
            اقدام نمایید.
          </p>
        </div>
        <div className="hero-sample-left">
          <img src={kargah} alt="downloadImg" />
        </div>
      </section>

      <Container className="d-flex flex-column justify-content-center overflow-hidden py-4 text-right">
        <Tabs
          defaultActiveKey={selectedTab}
          className="d-flex justify-content-center w-100 custom-tab-content flex-nowrap mb-5 ts-tab-content">
          <Tab
            eventKey="teacher-list"
            tabClassName="d-flex align-items-center flex-1"
            title={
              <Link to={{ hash: "teacher-list" }} className="addon-tabs">
                <h3>مدرسین</h3>
              </Link>
            }>
            {loading_state === Statics.CAUSED_ERROR && (
              <div className="error-parent mt-5">
                <p>ارتباط با سرور با مشکل مواجه شد !</p>
                <img
                  className="error-img"
                  src="images/errorPic.webp"
                  width="200px"
                  alt="error-png"
                />
              </div>
            )}
            <Teachers />
          </Tab>

          <Tab
            eventKey="workshop-list"
            tabClassName="d-flex align-items-center flex-1"
            title={
              <Link to={{ hash: "workshop-list" }} className="addon-tabs">
                <h3>کارگاه‌ها</h3>
              </Link>
            }>
            <Row className="justify-content-center">
              <Col>
                <Row className="justify-content-center">
                  <Col md={12} sm={12}>
                    {(loading_state === Statics.LOADING ||
                      loading_state === Statics.NOT_LOADED) && (
                      <div className="pajoohyar-loading">
                        <Loading />
                      </div>
                    )}

                    {loading_state === Statics.LOADED && (
                      <div className="ts-list workshop-list">
                        {/* کارت کارگاه سازمانی */}
                        <div
                          key="organizational"
                          className="ts-card organizational-workshop">
                          <h2>کارگاه سازمانی</h2>
                          <div className="workshop-desc text-right">
                            <p>
                              امکان برگزاری کارگاه اختصاصی برای سازمان‌ها با
                              سرفصل‌های سفارشی                            </p>
                          </div>
                          <div className="ts-buttons">
                            <Link
                              to="/workshop/order"
                              className="resume"
                              style={{
                                textAlign: "center",
                                verticalAlign: "middle",
                              }}
                              size="sm">
                              ثبت نام سازمانی
                            </Link>
                          </div>
                        </div>

                        {workshops.length ? (
                          workshops.map(workshop => (
                            <div key={workshop.id} className="ts-card">
                              <h2>{workshop.title}</h2>
                              <div className="workshop-desc text-right">
                                <p>
                                  توضیحات: {workshop.description}
                                  <br />
                                  ظرفیت: {workshop.capacity}
                                  <br />
                                  نوع کارگاه: {workshop.type.text}
                                  <br />
                                </p>
                                {workshop.meetings.data.length > 1
                                  ? workshop.meetings.data.map(
                                      (session, index) => (
                                        <WorkshopMeetingRow
                                          key={index}
                                          session={session}
                                          meetingNo={index + 1}
                                        />
                                      ),
                                    )
                                  : workshop.meetings.data.length === 1 && (
                                      <WorkshopMeetingRow
                                        session={workshop.meetings.data[0]}
                                        meetingNo={1}
                                      />
                                    )}
                                <span className="mx-1">قیمت :</span>
                                {workshop.offered_fee === workshop.fee ? (
                                  <b>{workshop.fee} ريال</b>
                                ) : (
                                  <>
                                    <del style={{ color: "red" }}>
                                      {workshop.fee} تومان
                                    </del>
                                    {"\u00A0"}
                                    <b>{workshop.offered_fee} تومان</b>
                                  </>
                                )}
                              </div>
                              <div className="ts-buttons">
                                <Link
                                  to={
                                    workshop.type.code === 2
                                      ? `/workshop/order/${workshop.id}`
                                      : `/workshop/register/${workshop.id}`
                                  }
                                  className="resume"
                                  style={{
                                    textAlign: "center",
                                    verticalAlign: "middle",
                                  }}
                                  size="sm">
                                  انتخاب
                                </Link>
                              </div>
                            </div>
                          ))
                        ) : (
                          <section className="hero-workshop">
                            <div className="hero-workshop-right text-right">
                              <h3>در حال حاضر کارگاهی وجود ندارد</h3>
                            </div>
                            <div className="hero-workshop-left text-left">
                              <img
                                src={noWorkshopHero}
                                alt="work-Img"
                                className="w-50"
                              />
                            </div>
                          </section>
                        )}
                      </div>
                    )}
                  </Col>
                </Row>
              </Col>
            </Row>
          </Tab>
        </Tabs>
      </Container>
    </DocumentMeta>
  );
};

export default WorkShop;
